import { formatPopulatedLocationLabel } from './geoUtils';

/**
 * Build unique Location-document options from businesses (for thread/post pickers).
 */
export const locationOptionsFromBusinesses = (businesses = []) => {
  const seen = new Set();
  const options = [];
  businesses.forEach((business) => {
    const loc = Array.isArray(business?.locations) ? business.locations[0] : null;
    if (!loc?._id || seen.has(loc._id)) return;
    seen.add(loc._id);
    options.push({
      value: loc._id,
      label: formatPopulatedLocationLabel(loc) || loc.address1 || loc._id,
    });
  });
  return options;
};
